/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Kids Home API
 * Gamified family chore / habit / allowance API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Presentational metadata only.
 */
export type QuestResponseQuestType =
  (typeof QuestResponseQuestType)[keyof typeof QuestResponseQuestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuestResponseQuestType = {
  daily: 'daily',
  weekly: 'weekly',
  epic: 'epic',
  story: 'story',
  seasonal: 'seasonal',
  custom: 'custom',
} as const;
